import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Modal, designTokens } from "@cinch-labs/design-system";
import { SVG, SVG_DEFAULT_GRADIENT_ID as DEFAULT_GRADIENT_ID, SVG_GRADIENT_IDS as GRADIENT_IDS } from "@cinch-nx/shared-ui";
import { Profile3D, HeartIcon, CarIcon, StarIcon, AlertIcon } from "./assets";
import { AuthButtons } from "./auth-buttons.component";
import { AuthModalV2 } from "./v2/auth-modal-v2";
import styles from "./auth-modal.module.css";
import { Env, readFromEnv } from "@cinch-nx/environments";
var space = designTokens.customProperties.ds.space;
var size = space["1-x"];
var gradientFill = GRADIENT_IDS ? "url(#".concat(GRADIENT_IDS[DEFAULT_GRADIENT_ID], ")") : "";
var iconStyle = {
    display: "inline-flex",
    width: size,
    height: size,
    fill: "none",
    stroke: gradientFill,
    strokeWidth: 1
};
var shouldShowAuthModalV2 = readFromEnv(Env.EnableFavouritingModalChanges) === "true";
export var AuthModal = function(param) {
    var isOpen = param.isOpen, handleClose = param.handleClose, useBrowserNavigation = param.useBrowserNavigation, vehicleImage = param.vehicleImage;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: isOpen && (shouldShowAuthModalV2 ? /*#__PURE__*/ _jsx(AuthModalV2, {
            handleClose: handleClose,
            vehicleImage: vehicleImage,
            useBrowserNavigation: !!useBrowserNavigation
        }) : /*#__PURE__*/ _jsxs(Modal, {
            classNames: {
                modal: styles.modal,
                inner: styles.modalInner
            },
            ariaLabelledById: "auth-modal-title",
            heading: "Register or log in",
            onClose: handleClose,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.body,
                    children: [
                        /*#__PURE__*/ _jsx(SVG, {
                            className: styles.icon,
                            children: Profile3D
                        }),
                        /*#__PURE__*/ _jsxs("ul", {
                            className: styles.bullets,
                            children: [
                                /*#__PURE__*/ _jsxs("li", {
                                    className: styles.bullet,
                                    children: [
                                        /*#__PURE__*/ _jsx(HeartIcon, {
                                            className: styles.bulletIcon,
                                            "aria-hidden": "true",
                                            style: _object_spread_props(_object_spread({}, iconStyle), {
                                                strokeWidth: 3
                                            })
                                        }),
                                        "Shortlist favourite cars"
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: styles.bullet,
                                    children: [
                                        /*#__PURE__*/ _jsx(StarIcon, {
                                            "aria-hidden": "true",
                                            style: _object_spread_props(_object_spread({}, iconStyle), {
                                                strokeWidth: 1.5,
                                                marginRight: size
                                            })
                                        }),
                                        "Save recommendations"
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: styles.bullet,
                                    children: [
                                        /*#__PURE__*/ _jsx(CarIcon, {
                                            className: styles.bulletIcon,
                                            "aria-hidden": "true",
                                            style: _object_spread_props(_object_spread({}, iconStyle), {
                                                fill: gradientFill
                                            })
                                        }),
                                        "Compare vehicles"
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: styles.bullet,
                                    children: [
                                        /*#__PURE__*/ _jsx(AlertIcon, {
                                            className: styles.bulletIcon,
                                            "aria-hidden": "true",
                                            style: _object_spread({}, iconStyle)
                                        }),
                                        "Many other features!"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(AuthButtons, {
                    useBrowserNavigation: useBrowserNavigation
                })
            ]
        }))
    });
};
